import { useEffect, useRef } from "react";
import styles from "./Style.module.css";
import useBookingTimer from "../../Utils/Hooks/useBookingTimer";

export default function HoldingCardTimer({ holdingCardTime, bookingId, onTimerExpired }) {
  const { remainingTime } = useBookingTimer(bookingId, holdingCardTime);
  const hasExpiredRef = useRef(false);
  const previousRemainingTimeRef = useRef(remainingTime);

  // Handle timer expiration - only call onTimerExpired when timer actually expires during countdown
  useEffect(() => {
    const previousTime = previousRemainingTimeRef.current;
    previousRemainingTimeRef.current = remainingTime;

    // Timer expired: was > 0, now is 0
    if (previousTime > 0 && remainingTime === 0 && !hasExpiredRef.current) {
      hasExpiredRef.current = true;
      if (onTimerExpired && bookingId) {
        // Use setTimeout to ensure state update completes before calling callback
        setTimeout(() => {
          onTimerExpired(bookingId);
        }, 0);
      }
    }
  }, [remainingTime, onTimerExpired, bookingId]);

  return (
    <div className={styles.holdingCardTimer}>
      {formatHoldCardTime(remainingTime)}
    </div>
  );
}

const formatHoldCardTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};
